// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "WETH",
    token: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x4d5F47FA6A74757f35C14fD3a6Ef8E3C9BC514E8",
    variableDebtTokenAddress: "0xeA51d7853EEFb32b6ee06b1C12E6dcCA88Be0fFE",
  },
  {
    symbol: "wstETH",
    token: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x0B925eD163218f6662a35e0f0371Ac234f9E9371",
    variableDebtTokenAddress: "0xC96113eED8cAB59cD8A66813bCB0cEb29F06D2e4",
  },
  {
    symbol: "WBTC",
    token: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x5Ee5bf7ae06D1Be5997A1A72006FE6C607eC6DE8",
    variableDebtTokenAddress: "0x40aAbEf1aa8f0eEc637E0E7d92fbfFB2F26A8b7B",
  },
  {
    symbol: "USDC",
    token: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x98C23E9d8f34FEFb1B7BD6a91B7FF122F4e16F5c",
    variableDebtTokenAddress: "0x72E95b8931767C79bA4EeE721354d6E99a61D004",
  },
  {
    symbol: "DAI",
    token: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x018008bfb33d285247A21d44E50697654f754e63",
    variableDebtTokenAddress: "0xcF8d0c70c850859266f5C338b38F9D663181C314",
  },
  {
    symbol: "LINK",
    token: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x5E8C8A7243651DB1384C0dDfDbE39761E8e7E51a",
    variableDebtTokenAddress: "0x4228F8895C7dDA20227F6a5c6751b8Ebf19a6ba8",
  },
  {
    symbol: "AAVE",
    token: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xA700b4eB416Be35b2911fd5Dee80678ff64fF6C9",
    variableDebtTokenAddress: "0xBae535520Abd9f8C85E58929e0006A2c8B372F74",
  },
  {
    symbol: "cbETH",
    token: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x977b6fc5dE62598B08C85AC8Cf2b745874E8b78c",
    variableDebtTokenAddress: "0x0c91bcA95b5FE69164cE583A2ec9429A569798Ed",
  },
  {
    symbol: "USDT",
    token: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x23878914EFE38d27C4D67Ab83ed1b93A74D4086a",
    variableDebtTokenAddress: "0x6df1C1E379bC5a00a7b4C6e67A203333772f45A8",
  },
  {
    symbol: "rETH",
    token: "0xae78736Cd615f374D3085123A210448E74Fc6393",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xCc9EE9483f662091a1de4795249E24aC0aC2630f",
    variableDebtTokenAddress: "0xae8593DD575FE29A9745056aA91C4b746eee62C8",
  },
  {
    symbol: "LUSD",
    token: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x3Fe6a295459FAe07DF8A0ceCC36F37160FE86AA9",
    variableDebtTokenAddress: "0x33652e48e4B74D18520f11BfE58Edd2ED2cEc5A2",
  },
  {
    symbol: "CRV",
    token: "0xD533a949740bb3306d119CC777fa900bA034cd52",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x7B95Ec873268a6BFC6427e7a28e396Db9D0ebc65",
    variableDebtTokenAddress: "0x1b7D3F4b3c032a5AE656e30eeA4e8E1Ba376068F",
  },
  {
    symbol: "MKR",
    token: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x8A458A9dc9048e005d22849F470891b840296619",
    variableDebtTokenAddress: "0x6Efc73E54E41b27d2134fF9f98F15550f30DF9B1",
  },
  {
    symbol: "SNX",
    token: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xC7B4c17861357B8ABB91F25581E7263E08DCB59c",
    variableDebtTokenAddress: "0x8d0de040e8aAd872eC3c33A3776dE9152D3c34ca",
  },
  {
    symbol: "BAL",
    token: "0xba100000625a3754423978a60c9317c58a424e3D",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x2516E7B3F76294e03C42AA4c5b5b4DCE9C436fB8",
    variableDebtTokenAddress: "0x3D3efceb4Ff0966D34d9545D3A2fa2dcdBf451f2",
  },
  {
    symbol: "UNI",
    token: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xF6D2224916DDFbbab6e6bd0D1B7034f4Ae0CaB18",
    variableDebtTokenAddress: "0xF64178Ebd2E2719F2B1233bCb5Ef6DB4bCc4d09a",
  },
  {
    symbol: "LDO",
    token: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x9A44fd41566876A39655f74971a3A6eA0a17a454",
    variableDebtTokenAddress: "0xc30808705C01289A3D306ca9CAB081Ba9114eC82",
  },
  {
    symbol: "ENS",
    token: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x545bD6c032eFdde65A377A6719DEF2796C8E0f2e",
    variableDebtTokenAddress: "0xd180D7fdD4092f07428eFE801E17BC03576b3192",
  },
  {
    symbol: "1INCH",
    token: "0x111111111117dC0aa78b770fA6A738034120C302",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x71Aef7b30728b9BB371578f36c5A1f1502a5723e",
    variableDebtTokenAddress: "0xA38fCa8c6Bf9BdA52E76EB78f08CaA3BE7c5A970",
  },
  {
    symbol: "FRAX",
    token: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xd4e245848d6E1220DBE62e155d89fa327E43CB06",
    variableDebtTokenAddress: "0x88B8358F5BC87c2D7E116cCA5b65A9eEb2c5EA3F",
  },
  {
    symbol: "GHO",
    token: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x00907f9921424583e7ffBfEdf84F92B7B2Be4977",
    variableDebtTokenAddress: "0x786dBff3f1292ae8F92ea68Cf93c30b34B1ed04B",
  },
  {
    symbol: "RPL",
    token: "0xD33526068D116cE69F19A9ee46F0bd304F21A51f",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xB76CF92076adBF1D9C39294FA8e7A67579FDe357",
    variableDebtTokenAddress: "0x8988ECA19D502fd8b9CCd03fA3bD20a6f599bc2A",
  },
  {
    symbol: "sDAI",
    token: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x4C612E3B15b96Ff9A6faED838F8d07d479a8dD4c",
    variableDebtTokenAddress: "0x8Db9D35e117d8b93C6Ca9b644b25BaD5d9908141",
  },
  {
    symbol: "STG",
    token: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x1bA9843bD4327c6c77011406dE5fA8749F7E3479",
    variableDebtTokenAddress: "0x655568bDd6168325EC7e58Bf39b21A856F906Dc2",
  },
  {
    symbol: "KNC",
    token: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x5b502e3796385E1e9755d7043B9C945C3aCCeC9C",
    variableDebtTokenAddress: "0x253127Ffc04981cEA8932F406710661c2f2c3fD2",
  },
  {
    symbol: "FXS",
    token: "0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x82F9c5ad306BBa1AD0De49bB5FA6F01bf61085ef",
    variableDebtTokenAddress: "0x68e9f0aD4e6f8F5DB70F6923d4d6d5b225B83b16",
  },
  {
    symbol: "crvUSD",
    token: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xb82fa9f31612989525992FCfBB09AB22Eff5c85A",
    variableDebtTokenAddress: "0x028f7886F3e937f8479efaD64f31B3fE1119857a",
  },
  {
    symbol: "PYUSD",
    token: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x0C0d01AbF3e6aDfcA0989eBbA9d6e85dD58EaB1E",
    variableDebtTokenAddress: "0x57B67e4DE077085Fd0AF2174e9c14871BE664546",
  },
  {
    symbol: "weETH",
    token: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xBdfa7b7893081B35Fb54027489e2Bc7A38275129",
    variableDebtTokenAddress: "0x77ad9BF13a52517AD698D65913e8D381300c8Bf3",
  },
  {
    symbol: "osETH",
    token: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x927709711794F3De5DdBF1D176bEE2D55Ba13c21",
    variableDebtTokenAddress: "0x8838eefF2af391863E1Bb8b1dF563F86743a8470",
  },
  {
    symbol: "USDe",
    token: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x4F5923Fc5FD4a93352581b38B7cD26943012DECF",
    variableDebtTokenAddress: "0x015396E1F286289aE23a762088E863b3ec465145",
  },
  {
    symbol: "ETHx",
    token: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x1c0E06a0b1A4c160c17545FF2A951bfcA57C0002",
    variableDebtTokenAddress: "0x08a8Dc81AeA67F84745623aC6c72CDA3967aab8b",
  },
  {
    symbol: "sUSDe",
    token: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x4579a27aF00A62C0EB156349f31B345c08386419",
    variableDebtTokenAddress: "0xeFFDE9BFA8EC77c14C364055a200746d6e12BeD6",
  },
  {
    symbol: "tBTC",
    token: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x10Ac93971cdb1F5c778144084242374473c350Da",
    variableDebtTokenAddress: "0xAC50890a80A2731eb1eA2e9B4F29569CeB06D960",
  },
  {
    symbol: "cbBTC",
    token: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x5c647cE0Ae10658ec44FA4E11A51c96e94efd1Dd",
    variableDebtTokenAddress: "0xeB284A70557EFe3591b9e6D9D720040E02c54a4d",
  },
  {
    symbol: "USDS",
    token: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x32a6268f9Ba3642Dda7892aDd74f1D34469A4259",
    variableDebtTokenAddress: "0x490E0E6255bF65b43E2e02F7acB783c5e04572Ff",
  },
  {
    symbol: "rsETH",
    token: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x2D62109243b87C4bA3EE7bA1D91B0dD0A074d7b1",
    variableDebtTokenAddress: "0x6De3E52A1B7294A34e271a508082b1Ff4a37E30e",
  },
  {
    symbol: "LBTC",
    token: "0x8236a87084f8B84306f72007F36F2618A5634494",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x65906988ADEe75306021C417a1A3458040239602",
    variableDebtTokenAddress: "0x68aeB290C7727D899B47c56d1c96AEAC475cD0dD",
  },
  {
    symbol: "eBTC",
    token: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x5fefd7069a7D91d01f269DADE14526CCF3487810",
    variableDebtTokenAddress: "0x47eD0509e64615c0d5C6d39AF1B38D02Bc9fE58f",
  },
  {
    symbol: "RLUSD",
    token: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xFa82580c16A31D0c1bC632A36F82e83EfEF3Eec0",
    variableDebtTokenAddress: "0xBdFe7aD7976d5d7E0965ea83a81Ca1bCfF7e84a9",
  },
  {
    symbol: "PT-eUSDE-29MAY2025",
    token: "0x50D2C7992b802Eef16c04FeADAB310f31866a545",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x4B0821e768Ed9039a70eD1E80E15E76a5bE5Df5F",
    variableDebtTokenAddress: "0x3c20fbFD32243Dd9899301C84bCe17413EeE0A0C",
  },
  {
    symbol: "PT-sUSDE-31JUL2025",
    token: "0x3b3fB9C57858EF816833dC91565EFcd85D96f634",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xDE6eF6CB4aBd3A473ffC2942eEf5D84536F8E864",
    variableDebtTokenAddress: "0x8C6FeaF5d58BA1A6541F9c4aF685f62bFCBaC3b1",
  },
  {
    symbol: "USDtb",
    token: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xEc4ef66D4fCeEba34aBB4dE69dB391Bc5476ccc8",
    variableDebtTokenAddress: "0xeA85a065F87FE28Aa8Fbf0D6C7deC472b106252C",
  },
  {
    symbol: "PT-USDe-31JUL2025",
    token: "0x917459337CaAC939D41d7493B3999f571D20D667",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x312ffC57778CEfa11989733e6E08143E7E229c1c",
    variableDebtTokenAddress: "0xd90DA2Df915B87fE1621A7F2201FbF4ff2cCA031",
  },
  {
    symbol: "PT-eUSDE-14AUG2025",
    token: "0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x2eDff5AF94334fBd7C38ae318edf1c40e072b73B",
    variableDebtTokenAddress: "0x22517fE16DEd08e52E7EA3423A2EA4995b1f1731",
  },
  {
    symbol: "eUSDe",
    token: "0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x5F9190496e0DFC831C3bd307978de4a245E2F5cD",
    variableDebtTokenAddress: "0x48351fCc9536dA440AE9471220F6dC921b0eB703",
  },
  {
    symbol: "FBTC",
    token: "0xC96dE26018A54D51c097160568752c4E3BD6C364",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xcCA43ceF272c30415866914351fdfc3E881bb7c2",
    variableDebtTokenAddress: "0x4A35FD7F93324Cc48bc12190D3F37493437b1Eff",
  },
  {
    symbol: "EURC",
    token: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xAA6e91C82942aeAE040303Bf96c15a6dBcB82CA0",
    variableDebtTokenAddress: "0x6c82c66622Eb360FC973D3F492f9D8E9eA538b08",
  },
  {
    symbol: "PT-sUSDE-25SEP2025",
    token: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x5f4a0873a3A02f7C0CB0e13a1d4362a1AD90e751",
    variableDebtTokenAddress: "0xc9AD8Dd111e6384128146467aAf92B81EC422848",
  },
  {
    symbol: "PT-USDe-25SEP2025",
    token: "0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x38A5357Ce55c81add62aBc84Fb32981e2626ADEf",
    variableDebtTokenAddress: "0x0D8486E1CAbf3C9407B3DdA0cfc4d9C3101fB683",
  },
  {
    symbol: "tETH",
    token: "0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x481a2acf3A72ffDc602A9541896Ca1DB87f86cf7",
    variableDebtTokenAddress: "0x7EC9Afe70f8FD603282eBAcbc9058A83623E2899",
  },
  {
    symbol: "ezETH",
    token: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x4E2a4d9B3DF7Aae73b418Bd39F3af9e148E3F479",
    variableDebtTokenAddress: "0x730318dB7b830d324fC3fEDDB1d212Ec64bD3141",
  },
  {
    symbol: "XAUt",
    token: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x8A2b6f94Ff3A89a03E8c02Ee92b55aF90c9454A2",
    variableDebtTokenAddress: "0xa665bB258D2a732C170dFD505924214c0b1AC74F",
  },
  {
    symbol: "PT-sUSDE-27NOV2025",
    token: "0xe6A934089BBEe34F832060CE98848359883749B3",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x285866acB0d60105B4Ed350a463361c2d9afA0E2",
    variableDebtTokenAddress: "0x690Df181701C11C53EA33bBF303C25834b66bD14",
  },
  {
    symbol: "PT-USDe-27NOV2025",
    token: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x38C503a438185cDE29b5cF4dC1442FD6F074F1cc",
    variableDebtTokenAddress: "0x2CE7e7b238985A8aD3863De03F200B245B0c1216",
  },
  {
    symbol: "PT-USDe-5FEB2026",
    token: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xE728577e9a1Fe7032bc309B4541F58f45443866e",
    variableDebtTokenAddress: "0x9D244A99801dc05cbC04183769c17056B8A1Ad53",
  },
  {
    symbol: "PT-sUSDE-5FEB2026",
    token: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xbe54767735fB7Acca2aa7E2d209a6f705073536D",
    variableDebtTokenAddress: "0xA803414f84fCEF00e745bE7CC2A315908927f15D",
  },
  {
    symbol: "mUSD",
    token: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xAa0200d169fF3ba9385c12E073c5d1d30434AE7b",
    variableDebtTokenAddress: "0xE35e6A0D3AbC28289f5d4C2d262a133Df936b98D",
  },
  {
    symbol: "syrupUSDT",
    token: "0x356B8d89c1e1239Cbbb9dE4815c39A1474d5BA7D",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x24Ab03a9a5Bc2C49E5523e8d915A3536ac38B91D",
    variableDebtTokenAddress: "0xAEf73b04654931B94920a3D7AE62032b79fB6d0c",
  },
  {
    symbol: "USDG",
    token: "0xe343167631d89B6Ffc58B88d6b7fB0228795491D",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x7c0477d085ECb607CF8429f3eC91Ae5E1e460F4F",
    variableDebtTokenAddress: "0x4f97B950a30321c181E974971E156E19fAD184A3",
  },
  {
    symbol: "PT-USDe-7MAY2026",
    token: "0xAeBf0Bb9f57E89260d57f31AF34eB58657d96Ce0",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xE036478Da9A7ed89b56FE39A06e1FC1a4b38D4Ea",
    variableDebtTokenAddress: "0x04142fc546D59838852873bba5C8827601A13FC8",
  },
  {
    symbol: "PT-sUSDE-7MAY2026",
    token: "0x3de0ff76E8b528C092d47b9DaC775931cef80F49",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x81b76ff3FeD28BA0B4a5D4c76Bd5C13Bd0641d86",
    variableDebtTokenAddress: "0x762Edb8D79b97487F82093f85059e42EeEf61E9e",
  },
  {
    symbol: "PT-srUSDe-2APR2026",
    token: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x1241ec22C9BdF16BA1Eb636F2a8de7e28A4343Cf",
    variableDebtTokenAddress: "0xacD3d3FaCeA0424984F662827B988f4581a3cE31",
  },
  {
    symbol: "BTC.b",
    token: "0xB0F70C0bD6FD87dbEb7C10dC692a2a6106817072",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x12b70410D60f926558245f769059eA3Fc7A7353E",
    variableDebtTokenAddress: "0x6C67e666BB954d4bE23e9F1cE20e7E8699d29339",
  },
  {
    symbol: "PT-srUSDe-25JUN2026",
    token: "0x619D75E3b790eBC21c289f2805Bb7177A7D732E2",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xA78Eba24D89e70A03ddB7AC195A15E53315aA5b4",
    variableDebtTokenAddress: "0x9Ba896531F878Ed5f0A4F73E82d63bA7b424F910",
  },
  {
    symbol: "PT-USDG-28MAY2026",
    token: "0x9db38D74a0D29380899aD354121DfB521aDb0548",
    usageAsCollateralEnabled: false,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xA9ecb0503075124cc0B786096849A331FBe9EE6D",
    variableDebtTokenAddress: "0x1a83eCA2d3b0cea2595Fb11Ec60cb2D428217C2e",
  },
] as const
